// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundFilter_filterPanel__FtuQU {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    width: 100%;
    margin-top: 15px;
    overflow: hidden;
    font-family: "Syne", sans-serif;
}

.BackgroundFilter_hidden__ecHKz {
    display: none;
}

.BackgroundFilter_filterHeader__KyaCb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background-color: #f8f8f8;
    border-bottom: 1px solid #eee;
}

.BackgroundFilter_filterHeader__KyaCb h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
}

.BackgroundFilter_closeButton__6xu6j {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #777;
}

.BackgroundFilter_closeButton__6xu6j:hover {
    color: #333;
}

.BackgroundFilter_filterContent__fE7Vb {
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.BackgroundFilter_filterOption__tZ7Nk {
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #f8f8f8;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
    font-family: "Syne", sans-serif;
}

.BackgroundFilter_filterOption__tZ7Nk:hover {
    background-color: #f0f0f0;
}

.BackgroundFilter_filterOption__tZ7Nk.BackgroundFilter_active__JgkYC {
    background-color: #6616cd;
    color: white;
    border-color: #6616cd;
}

@media (max-width: 768px) {
    .BackgroundFilter_filterPanel__FtuQU {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Chat/BackgroundFilter.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;IACvC,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".filterPanel {\n    background-color: white;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    width: 100%;\n    margin-top: 15px;\n    overflow: hidden;\n    font-family: \"Syne\", sans-serif;\n}\n\n.hidden {\n    display: none;\n}\n\n.filterHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 15px;\n    background-color: #f8f8f8;\n    border-bottom: 1px solid #eee;\n}\n\n.filterHeader h3 {\n    margin: 0;\n    font-size: 16px;\n    color: #333;\n}\n\n.closeButton {\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #777;\n}\n\n.closeButton:hover {\n    color: #333;\n}\n\n.filterContent {\n    padding: 15px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.filterOption {\n    padding: 5px 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    background-color: #f8f8f8;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    font-family: \"Syne\", sans-serif;\n}\n\n.filterOption:hover {\n    background-color: #f0f0f0;\n}\n\n.filterOption.active {\n    background-color: #6616cd;\n    color: white;\n    border-color: #6616cd;\n}\n\n@media (max-width: 768px) {\n    .filterPanel {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterPanel": `BackgroundFilter_filterPanel__FtuQU`,
	"hidden": `BackgroundFilter_hidden__ecHKz`,
	"filterHeader": `BackgroundFilter_filterHeader__KyaCb`,
	"closeButton": `BackgroundFilter_closeButton__6xu6j`,
	"filterContent": `BackgroundFilter_filterContent__fE7Vb`,
	"filterOption": `BackgroundFilter_filterOption__tZ7Nk`,
	"active": `BackgroundFilter_active__JgkYC`
};
export default ___CSS_LOADER_EXPORT___;
